/* eslint-disable import/no-anonymous-default-export */
export default {
  identityPoolId: "us-east-1:3d436bb5-fd43-4a1f-954c-79b1e9169576",
  region: "us-east-1",
};
